export default "__VITE_ASSET__BpJVbGDZ__"